import { render, staticRenderFns } from "./ChartsReport.vue?vue&type=template&id=0b5126f7&"
import script from "./ChartsReport.vue?vue&type=script&lang=js&"
export * from "./ChartsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports